import setStyle from '../setStyle'
import _ from 'lodash'
import {textWidth} from '@/utils'
const publicMethods = {
  props: ['chartFont', 'lineStyle', 'bgc', 'controlData'],
  mixins: [setStyle],
  data () {
    return {
      // 9种基础色
      basicColor: ['#60acfc', '#32d3eb', '#9cdc82', ' #d4ec59', '#ffe168', '#feb64d', '#fb6e6c', '#9287e7', '#6370de'],
      // 16种补充色
      replenishColor: ['#27a1ea', '#2fb0d2 ', '#5bc49f', '#77e633', '#e5c33c ', '#ff9f69 ', '#e9668e', '#b55cbd', '#668ed6 ', '#9fcdfd', '#84e4f3 ', '#fed394 ', '#fca8a6', '#d29dd7 ', '#a79feb ', '#84a4de'],
      minWidth: 20
    }
  },
  methods: {
    // 处理x轴y轴的宽度
    getCount () {
      let list = this.$_.merge([], this.graphData)
      let count = 0
      list && list.length && list.forEach(li => {
        if (li.dataDimension && li.dataDimension.length) {
          li.dataDimension.map(d => d.value).forEach(c => {
            if (c !== null && c !== undefined) {
              count += c
            }
          })
        }
      })
      return count
    },
    extension (line) {
      if (!document.getElementById('extension-graph')) {
        let div = document.createElement('div')
        div.setAttribute('id', 'extension-graph')
        div.style.display = 'none'
        document.body.appendChild(div)
      }
      line.on('mouseover', params => {
        let extension = document.getElementById('extension-graph')
        if (params.componentType === 'xAxis' && extension) {
          extension.innerText = params.value
          extension.setAttribute('class', 'histogram-extension')
          extension.setAttribute('style', `top: ${event.pageY - 20}px; left: ${event.pageX + 15}px`)
        }
      })
      line.on('mouseout', params => {
        let extension = document.getElementById('extension-graph')
        if (extension) {
          extension.style.display = 'none'
        }
      })
    },
    formatMoney (number) {
      if (!number || number.toString().length < 4) return number
      let arr = number.toString().split('.')
      return `${arr[0].replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}${arr[1] ? '.' + arr[1] : ''}`
    },
    getRandomColorList (length) {
      let colors = []
      let color = '#'
      // 一个十六进制的值的数组
      let list = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f']
      while (colors.length !== length) {
        for (let i = 0; i < 6; i++) {
          let num = parseInt(Math.random() * 16)
          color += list[num]
        }
        if (!colors.includes(color)) {
          colors.push(color)
          color = '#'
        }
      }
      return colors
    },
    getDefaultColors (length) {
      let colors = []
      if (length < 25) {
        if (length <= 9) {
          colors = this.basicColor.slice(0, length)
        } else {
          colors = [...this.basicColor, ...this.replenishColor]
        }
      } else {
        colors = [...this.basicColor, ...this.replenishColor, ...this.getRandomColorList(length - 25)]
      }
      return colors
    },
    // 从基础色或者补充色中获取颜色
    disposeXAxle (value) {
      value = this.disposeYear(value)
      // 如果x轴的数据超过五个，并且x轴一个坐标上的数据超过三个，则展示8个字符，否则展示全部
      if (this.graphData.length <= 5) {
        if (this.graphData[0].dataDimension && this.graphData[0].dataDimension.length < 3) {
          return (value.length > 15 ? (value.slice(0, 15) + '...') : value)
        }
      }
      return (value.length > 8 ? (value.slice(0, 8) + '...') : value)
    },
    setEndValue () {
      if (this.graphData.length <= 5) {
        if (this.graphData[0].dataDimension && this.graphData[0].dataDimension.length < 3) {
          this.end = 100
        }
      } else {
        this.end = 50
      }
    },
    disposeYear (value) {
      let date = value
      // x 轴如果设置的是年月日，则只展示月，日不展示年
      if (this.dimensionality && this.dimensionality.length > 0) {
        let d = this.dimensionality[0]
        let type = d.dataType || d.columnType
        let unit = d.dimensionality ? d.dimensionality.unit : d.unit
        if ((type.toUpperCase() === 'DATE' || type.toUpperCase() === 'DATETIME') && unit === 'DAY') {
          if (value.includes('年')) {
            date = value.split('年')[1]
          }
        }
      }
      return date
    },
    setEchartsVisual (type) {
      let chartContainer = this.$parent.$el && this.$parent.$el.querySelector('.chart-container')
      this.$refs[type].style.width = (chartContainer && (chartContainer.clientWidth - 40 + 'px')) || '100%'
      this.$refs[type].style.height = (chartContainer && (chartContainer.clientHeight - 40 + 'px')) || '100%'
    },
    // 显式设置echarts容器可视大小,否则在切换标签页时echarts无法获取容器大小导致变形
    dealWithXYLabelWidth (options, type = 'bar') {
      const grid = {}
      const fontSize = isNaN(this.getTextStyle.fontSize) ? 14 : this.getTextStyle.fontSize
      // 处理x轴
      if (this.options.xAxisData && this.options.xAxisData.length) {
        const maxXText = _.orderBy(this.options.xAxisData, item => String(item).length).pop()
        grid.bottom = textWidth(maxXText, fontSize) || ''
        const xWidth = textWidth(this.options.xAxisData[this.options.xAxisData.length - 1], fontSize) || 0
        grid.right = xWidth / 2
      }
      const findSeries = this.options.series.find(it => it.type === type)
      if (findSeries && findSeries.data && findSeries.data.length) {
        const maxYText = _.orderBy(findSeries.data, item => String(item).length).pop()
        const yWidth = textWidth(maxYText, fontSize) || 38
        if (yWidth < 38 + yWidth) {
          grid.left = yWidth + 38
        } else {
          grid.left = (yWidth / 2) + 38
          grid.axisLabel.rotate = 45
        }
        grid.top = grid.left
      }
      options.grid = grid
    },
    getWH () {
      if (this.isMagnify) {
        return {
          height: '400px'
        }
      }
      if (this.controlData) {
        const title = this.controlData.title
        return {
          width: this.controlData.width - 20 - (title ? 42 : 0),
          height: this.controlData.height - 20 - (title ? 42 : 0)
        }
      }
      const chartRefs = this.$refs.chart
      if (chartRefs) {
        const { width, height } = chartRefs.getBoundingClientRect()
        return {
          width: width - 10,
          height: height - 10
        }
      }
      return {
        width: 'auto',
        height: 'auto'
      }
    },
    getTooltipOptions () {
      return {
        show: true, // 是否显示
        trigger: 'axis', // 触发类型  'item'图形触发：散点图，饼图等无类目轴的图表中使用； 'axis'坐标轴触发；'none'：什么都不触发。
        axisPointer: { // 坐标轴指示器配置项。
          type: 'line', // 'line' 直线指示器  'shadow' 阴影指示器  'none' 无指示器  'cross' 十字准星指示器。
          axis: 'auto', // 指示器的坐标轴。
          snap: true // 坐标轴指示器是否自动吸附到点上
        },
        renderMode: 'html', // 浮层的渲染模式，默认以 'html 即额外的 DOM 节点展示 tooltip；
        padding: 5, // 提示框浮层内边距，
        confine: false, // 是否将 tooltip 框限制在图表的区域内。
        position: point => [point[0] - 20, '10%']
      }
    }
  },
  computed: {
    getLegend () {
      return (end, start = 0) => {
        if (!this.options) return []
        let legendData = this.$_.merge([], this.options.legendData)
        let list = []
        legendData && legendData.forEach((l, i) => {
          if (i >= start && i < end) {
            list.push({name: l, color: this.options.color[i]})
          }
        })
        return list
      }
    },
    // 根据x轴的坐标个数和x轴所对应的柱子的个数计算画布所需要的的宽度。
    // 一个柱子的最小宽度为多少？
    calculateWidth () {
      let x = this.graphData.length
      let barCount = 0
      if (this.graphData.length > 0) {
        barCount = this.graphData[0].dataDimension ? this.graphData[0].dataDimension.length : 0
      }
      let width = (barCount * (this.minWidth + 15) * x)
      return (width < 1000 ? this.$refs.chart && this.$refs.chart.offsetWidth : width) + 'px'
    },
    // 折线图的x轴的宽度是默认一个位置放几个文字
    // 暂时留着 后期可能要用
    calculateLineWidth () {},
    getTextStyle () {
      let style = {color: '#333'}
      if (this.chartFont) {
        let font = this.getCharFontStyle(this.chartFont)
        if (!font.color) {
          font.color = '#333'
        }
        style = font
      }
      return style
    },
    getLineStyle () {
      let border = {...this.lineStyle}
      border.type = border.style
      if (!border.width) {
        border.width = 1
      } else {
        border.width = parseFloat(border.width)
      }
      if (!border.color) {
        border.color = '#ddd'
      }
      if (!border.type) {
        border.type = 'solid'
      }
      delete border.style
      return border
    },
    getCharTextStyle () {
      const style = this.getTextStyle
      const font = this.getCharFontStyle(this.chartFont)
      if (!font.color) {
        style.color = '#999'
      }
      return style
    }
  },
  mounted () {
    document.getElementById('app').addEventListener('click', () => {
      if (this.isOpen) {
        this.isOpen = false
      }
    })
  },
  beforeDestroy () {
    document.getElementById('app').removeEventListener('click', () => {})
  }
}
export { publicMethods }



// WEBPACK FOOTER //
// ./src/components/public/graphReport/mixin.js